import { useCallback } from 'react';
import { useParams } from 'react-router';
import NotesHeader from './components/NotesHeader';
import NotesSection from './components/NotesSection';
import NotesListBase from './components/NotesList';
import useNotesForAnchor from './hooks/useNotesForAnchor';

const Header = () => <NotesHeader title="Farm Notes" />;

/**
 * Displays the Notes for a Farm.
 */
const DirectFarmNotes = () => {
  const { farmId } = useParams();
  const notes = useNotesForAnchor(farmId);

  const FarmNotesList = useCallback(() => <NotesListBase notes={notes} />, [
    notes,
  ]);

  return (
    // @ts-expect-error NotesSection not migrated to TS
    <NotesSection anchorId={farmId} NotesList={FarmNotesList} Header={Header} />
  );
};

export default DirectFarmNotes;
